var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishedWithChanges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 11.5968C4.725 11.5218 4.06172 11.3273 3.44766 11.0132C2.83359 10.6992 2.29922 10.2914 1.84453 9.78979C1.38984 9.28823 1.03125 8.71401 0.76875 8.06714C0.50625 7.42026 0.375 6.7312 0.375 5.99995C0.375 5.14683 0.546094 4.35933 0.888281 3.63745C1.23047 2.91558 1.69687 2.29683 2.2875 1.7812H0.9375V0.656201H4.3125V4.0312H3.1875V2.49839C2.67188 2.91089 2.26172 3.41948 1.95703 4.02417C1.65234 4.62886 1.5 5.28745 1.5 5.99995C1.5 7.15308 1.87734 8.14917 2.63203 8.98823C3.38672 9.82729 4.32187 10.3171 5.4375 10.4578V11.5968ZM5.19844 8.58745L2.82187 6.19683L3.60938 5.40933L5.19844 6.99839L8.39062 3.8062L9.17813 4.60776L5.19844 8.58745ZM7.6875 11.3437V7.9687H8.8125V9.50151C9.32812 9.07964 9.73828 8.5687 10.043 7.9687C10.3477 7.3687 10.5 6.71245 10.5 5.99995C10.5 4.84683 10.1227 3.85073 9.36797 3.01167C8.61328 2.17261 7.67812 1.68276 6.5625 1.54214V0.403076C7.9875 0.543701 9.1875 1.1437 10.1625 2.20308C11.1375 3.26245 11.625 4.52808 11.625 5.99995C11.625 6.85308 11.4539 7.64058 11.1117 8.36245C10.7695 9.08433 10.3031 9.70308 9.7125 10.2187H11.0625V11.3437H7.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedWithChanges);
export default __webpack_public_path__ + "static/media/published_with_changes.358dbe2908b7812136e6a15247745799.svg";
export { ForwardRef as ReactComponent };